import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from "../context/AppContext";
import SimpleReactValidator from "simple-react-validator";
import { createKeys, getKeys } from '../services/companyServices';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { toast } from 'react-toastify';
import { getPlan } from '../services/adminServices';

const CompanyKeys = () => {
  const { login } = useContext(AppContext);
  const [validatorCount, setValidatorCount] = useState(0);
  const forceUpdate = () => setValidatorCount(validatorCount + 1);
  const initial = new SimpleReactValidator({ locale: "en", autoForceUpdate: { forceUpdate } });
  const [validator, setValidator] = useState(initial);
  const [pricing, setPricing] = useState({
    user: { price: '', discount: '' },
    advertisment: { price: '', discount: '' },
    tracking: { price: '', discount: '' },
    calling: { price: '', discount: '' },
  });
  const [keys, setKeys] = useState([]);
  const [latestKey, setLatestKey] = useState({});
  const [filter, setFilter] = useState({ name: "", limit: 5, page: 1 });
  const [pagination, setPagination] = useState({});
  let date = new Date();
  const [newKey, setNewKey] = useState({
    keyType: "2day",
    expiryDate: date.setDate(date.getDate() + 2),
    advertisment: false,
    moreUser: 0
  });
  const [isModalOpen, setIsModalOpen] = useState(false);


  const getAllKeys = async (filters = filter) => {
    try {
      let result = await getKeys(login.token, filters);
      setPagination(result.pagination)
      setLatestKey(result.latestKey)
      setKeys(result.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleCreateKey = async () => {
    try {
      if (validator.allValid()) {
        let obj = newKey
        if (newKey.isEdit) {
          obj.user = parseInt(obj.user) + parseInt(obj.moreUser)
        }
        const { total, breakdown } = calculateTotalPrice(parseInt(newKey.isEdit ? (newKey.moreUser || 0) : (newKey.user)), pricing, newKey.isEdit);
        if (newKey.isEdit) {
          obj.total = obj.total + total
          obj.breakdown = [...obj.breakdown, breakdown]
        } else {
          obj.total = total
          obj.breakdown = [breakdown]
        }
        const result = await createKeys(login.token, obj);
        if (result.success) {
          toast.success(result.message);
          setNewKey();
          getAllKeys();
          setIsModalOpen(false);
        } else {
          toast.error(result.message);
        }
      } else {
        validator.showMessages();
        forceUpdate();
      }
    } catch (error) {
      console.error("Error creating key request:", error);
      toast.error("Failed to create key request.");
    }
  };

  const handleNext = () => {
    if (pagination.currentPage < pagination.totalPages) {
      const newPage = pagination.currentPage + 1;
      setFilter({ ...filter, page: newPage });
      getAllKeys({ ...filter, page: newPage });
    }
  };

  const handlePrev = () => {
    if (pagination.currentPage > 1) {
      const newPage = pagination.currentPage - 1;
      setFilter({ ...filter, page: newPage });
      getAllKeys({ ...filter, page: newPage });
    }
  };

  const getPricingPlan = async (e) => {
    let result = await getPlan(login.token)
    if (result.success) {
      setPricing(result.data)
    }
  };

  function calculateTotalPrice(userCount, pricingPlan, isEdit) {
    if (!pricingPlan || typeof userCount !== 'number') {
      return { total: 0, breakdown: {} };
    }

    const sections = ['remote', 'advertisment', 'tracking', 'calling'];
    const details = {};
    let grandTotal = 0;

    sections.forEach((section) => {
      const plan = pricingPlan[section];
      if (!plan?.isActive) {
        return; // Skip if not active
      }
      if (!newKey[section]) {
        return;
      }

      const pricePerUser = plan.price || 0;
      const discountPercent = plan.discount || 0;
      const expiry = new Date(newKey.expiryDate);
      const latestKeyEpiry = (latestKey?.expiringAt && !isEdit) ? new Date(latestKey?.expiringAt) : new Date();

      // Calculate the number of full days between now and expiry
      const diffInTime = expiry.getTime() - latestKeyEpiry.getTime();
      const diffInDays = Math.ceil(diffInTime / (1000 * 60 * 60 * 24)); // Round up to cover partial days

      const baseAmount = userCount * pricePerUser * Math.max(diffInDays, 0);
      const gross = parseInt(baseAmount);

      const discountAmount = (gross * discountPercent) / 100;
      const net = gross - discountAmount;

      details[section] = {
        users: userCount,
        pricePerUser,
        diffInDays: diffInDays > 0 ? diffInDays : 0,
        gross,
        discountPercent,
        discountAmount,
        net,
      };

      grandTotal += net;
    });

    const gst = (grandTotal * 0.18).toFixed(2);
    const gross = parseInt(grandTotal) + parseInt(gst);

    return {
      subtotal: grandTotal,
      gst,
      total: gross,
      breakdown: details,
    };
  }



  useEffect(() => {
    setKeys([]);
    getAllKeys();
    getPricingPlan()
  }, []);

  validator.purgeFields();

  const expiringAt = new Date(latestKey.expiringAt).getTime();
  const newExpiry = new Date(newKey.expiryDate).getTime();

  const isButtonEnabled = expiringAt < newExpiry;

  return (
    <div className="details-table mt-3">
      <div className="search-container mb-3">
        <h4>
          <i class="fas fa-key"></i>
          Key Details :
        </h4>
        <div className="headerWrap">
          <form onSubmit={(e) => {
            e.preventDefault();
            getAllKeys();
          }} className="d-flex">
            <button type="submit" id="searchButton" style={{ background: "none", border: "none", padding: 0 }}>
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.5 21.5C16.7467 21.5 21 17.2467 21 12C21 6.75329 16.7467 2.5 11.5 2.5C6.25329 2.5 2 6.75329 2 12C2 17.2467 6.25329 21.5 11.5 21.5Z" stroke="#657488" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M22 22.5L20 20.5" stroke="#657488" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
              </svg>
            </button>
            <input
              className="fs-18 tableSearch"
              type="text"
              value={filter.name}
              onChange={(e) => setFilter({ ...filter, name: e.target.value })}
              id="searchInput"
              name="search"
              placeholder="Search here . . ."
            />
          </form>
        </div>
      </div>
      <div className="add-user py-3 text-end">
        <a onClick={() => { setNewKey({ keyType: "2day", expiryDate: date, advertisment: false, moreUser: 0 }); setIsModalOpen(true) }}>
          <i class="fas fa-key" style={{ fontSize: "24px" }}></i>
        </a>
      </div>
      <table id="example" className="display" style={{ "width": "100%" }}>
        <thead>
          <tr>
            <th>No</th>
            <th>Plan Type</th>
            <th>Expiring At</th>
            <th>Key</th>
            <th>Status</th>
            <th>Price</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {
            keys.map((x, i) => {
              return (
                <tr key={x._id}>
                  <td>{((pagination.currentPage - 1) * filter.limit) + (i + 1)}</td>
                  <td>{x.keyType}</td>
                  <td>{moment(x.expiringAt).format("DD-MM-YY")}</td>
                  <td style={{ lineBreak: "anywhere" }}>
                    <div className="supportNumber d-flex align-items-center position-relative main-tooltip">
                      <p
                        id="supportText"
                        className="flex-grow-1 text-break position-relative"
                        style={{ marginRight: "10px", width: "90%" }}
                      >
                        {x.key}
                        <button
                          onClick={() => {
                            navigator.clipboard
                              .writeText(x.key)
                              .then(() => toast.success("Copied to clipboard!"))
                              .catch((err) => toast.error("Failed to copy text: " + err));
                          }}
                          className="btn btn-warning btn-sm position-absolute top-50 end-0 translate-middle-y"
                          style={{ display: "none", backgroundColor: "#8ec73c" }}
                        >
                          Copy
                        </button>
                      </p>
                      <p className='tooltip' style={{ width: "180px" }}>
                        <p>
                          {"User " + (x.user ? x.user : "Unlimited")}
                        </p>
                        <p>
                          {"Calling " + (x.calling ? "Enabled" : "Disabled")}
                        </p>
                        <p>
                          {"Tracking " + (x.tracking ? "Enabled" : "Disabled")}
                        </p>
                        <p>
                          {"Advertisement " + (x.advertisment ? "Enabled" : "Disabled")}
                        </p>
                      </p>
                    </div>
                  </td>
                  <td>{x.status}</td>
                  <td>{x.total}</td>
                  <td>{x.status == "Approved" && <button className='btn btn-success' style={{ background: "#8ec73c", border: "none" }} onClick={() => { setIsModalOpen(true); setNewKey({ ...x, expiryDate: x.expiringAt, isEdit: true }) }}>Edit</button>}</td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
      <div className="custom-pagination">
        <span className="showing-entries">Showing {(pagination.currentPage - 1) * filter.limit + 1} - {Math.min((pagination.currentPage) * filter.limit, pagination.totalDocuments)} of {pagination.totalDocuments}</span>
        <div className="page-controls">
          <button
            className="page-btn prev"
            onClick={handlePrev}
            disabled={pagination.currentPage === 1} // Disable button on first page
          >
            <i className="fas fa-chevron-left"></i>
          </button>
          <span className="current-page">{pagination.currentPage}</span>
          <span className="separator">/</span>
          <span className="total-pages">{pagination.totalPages}</span>
          <button
            className="page-btn next"
            onClick={handleNext}
            disabled={pagination.currentPage === pagination.totalPages} // Disable button on last page
          >
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
      {isModalOpen && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Request Key</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setIsModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="row g-3">
                    {newKey.isEdit ? <>
                    </> : <>
                      <div className="col-lg-12">
                        <label for="name" className="form-label">Plan Type</label>
                        <select
                          className="form-control"
                          id="timePeriod"
                          value={newKey.keyType}
                          onChange={(e) => {
                            const selectedPeriod = e.target.value;
                            let expiryDate = new Date(); // Current date
                            switch (selectedPeriod) {
                              case "2day":
                                expiryDate.setDate(expiryDate.getDate() + 2);
                                break;
                              case "week":
                                expiryDate.setDate(expiryDate.getDate() + 7);
                                break;
                              case "month":
                                expiryDate.setMonth(expiryDate.getMonth() + 1);
                                break;
                              default:
                                expiryDate = null; // For custom, leave it undefined or handle it differently
                                break;
                            }
                            setNewKey({ ...newKey, keyType: selectedPeriod, expiryDate });
                          }
                          }
                        >
                          <option value="2day">2 Day</option>
                          <option value="week">Week</option>
                          <option value="month">Month</option>
                          <option value="custom">Custom</option>
                        </select>
                        <span className="text-danger small">{validator.message("keyType", newKey.keyType, "required")}</span>
                      </div>
                      {newKey.keyType == "custom" && <div className="col-lg-12">
                        <label className="form-label fw-bold">By Date Range:</label>
                        <DatePicker
                          selected={newKey.expiryDate} // Single date selection for end date
                          onChange={(date) => setNewKey({ ...newKey, expiryDate: date })} // Update only the end date
                          className="form-control"
                          calendarStartDay={1} // Start the week on Monday
                          minDate={new Date()} // Disable future dates
                          placeholderText="Select end date"
                        />

                      </div>}
                    </>}
                    <div className={newKey.isEdit ? "col-lg-6" : "col-lg-12"}>
                      <label htmlFor="userName" className="form-label">User</label>
                      <input
                        className="form-control"
                        id="userName"
                        type="number"
                        value={newKey.user}
                        disabled={newKey.isEdit}
                        onChange={(e) => setNewKey({ ...newKey, user: e.target.value })}
                        placeholder="No of users"
                      />
                      <span className="text-danger small">{validator.message("user", newKey.user, "required")}</span>
                    </div>
                    {
                      newKey.isEdit && <>
                        <div className="col-lg-3">
                          <label htmlFor="userName" className="form-label"> Add User</label>
                          <input
                            type="text"
                            className="form-control"
                            id="userName"
                            value={newKey.moreUser}
                            onChange={(e) => setNewKey({ ...newKey, moreUser: e.target.value })}
                            placeholder="Add More Users Here"
                          />
                        </div><div className="col-lg-3">
                          <label htmlFor="userName" className="form-label"> Total User</label>
                          <input
                            type="text"
                            className="form-control"
                            id="userName"
                            value={parseInt(newKey.user) + (parseInt(newKey.moreUser) || 0)}
                            disabled
                            onChange={(e) => setNewKey({ ...newKey, user: e.target.value })}
                          />
                          <span className="text-danger small">{validator.message("user", newKey.user, "required")}</span>
                        </div>
                      </>
                    }
                    <div className="col-lg-12">
                      <div className="form-check mt-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="remote"
                          checked={newKey.remote}
                          disabled={newKey.isEdit}
                          onChange={(e) => setNewKey({ ...newKey, remote: e.target.checked })}
                        />
                        <label className="form-check-label" htmlFor="remote">
                          Remote
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-check mt-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="tracking"
                          checked={newKey.tracking}
                          disabled={newKey.isEdit}
                          onChange={(e) => setNewKey({ ...newKey, tracking: e.target.checked })}
                        />
                        <label className="form-check-label" htmlFor="tracking">
                          Tracking
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-check mt-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="advertisment"
                          checked={newKey.advertisment}
                          disabled={newKey.isEdit}
                          onChange={(e) => setNewKey({ ...newKey, advertisment: e.target.checked })}
                        />
                        <label className="form-check-label" htmlFor="advertisment">
                          Remove Advertisement
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-check mt-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="calling"
                          checked={newKey.calling}
                          disabled={newKey.isEdit}
                          onChange={(e) => setNewKey({ ...newKey, calling: e.target.checked })}
                        />
                        <label className="form-check-label" htmlFor="calling">
                          Calling
                        </label>
                      </div>
                    </div>
                    {newKey.user > 0 && (() => {
                      const { total, subtotal, gst, breakdown } = calculateTotalPrice(parseInt(newKey.isEdit ? (newKey.moreUser || 0) : (newKey.user)), pricing, newKey.isEdit);

                      return (
                        <div className="bg-light rounded p-3">
                          <div>
                            {Object.entries(breakdown).map(([key, item]) => {
                              const hasDiscount = item.discountPercent > 0;
                              const original = `${item.users} User × ₹${item.pricePerUser} Per Day x ${item.diffInDays} Day`;
                              const discounted = `₹${item.net} (-${item.discountPercent}%)`;

                              return (
                                <div key={key} className="border-bottom py-2">
                                  <span className="fw-semibold text-capitalize">{key}:</span>{' '}
                                  {hasDiscount ? (
                                    <>
                                      <span className="text-decoration-line-through text-muted me-2">{original}</span>
                                      <span className="text-success fw-semibold">{discounted}</span>
                                    </>
                                  ) : (
                                    <span className="text-dark">{original}</span>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                          <div className="fw-bold text-primary" style={{ justifySelf: "end" }}>
                            Subtotal: ₹{subtotal}
                          </div>
                          <div className="fw-bold text-primary" style={{ justifySelf: "end" }}>
                            GST: ₹{gst}
                          </div>
                          <div className="fw-bold text-primary" style={{ justifySelf: "end" }}>
                            Total: ₹{total}
                          </div>
                        </div>

                      );
                    })()}

                    <div className="col-lg-6">
                      Key will expire at {moment(newKey.expiryDate).format("DD-MMM-YYYY")}
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ backgroundColor: '#1edd60', border: "none" }}
                  disabled={!isButtonEnabled && !newKey.isEdit}
                  onClick={handleCreateKey}
                >
                  Request Key
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default CompanyKeys
